//@ts-nocheck
/**
 * This is a TypeGen auto-generated file.
 * Any changes made to this file can be lost when this file is regenerated.
 */

import { FeatureFlag } from "../FeatureFlag";

export const ShortBehaviorRetries: FeatureFlag = {"Id":"ShortBehaviorRetries","Label":"(QA) Failed behaviors retry after 1 second","Impact":"For QA. Auto-retry of failed behaviors occurs immediately, instad of having to wait minutes to days.","Mode":1,"ActiveOn":null,"ActiveUntil":null,"GlobalEnabled":false,"TenantEnabled":null,"UserEnabled":null,"Scope":7};
